/**
 * SqlViewerModal — a read-only SQL viewer in a modal, using the shared
 * CodeMirror editor (MySQL highlighting + one-dark theme). Used by the Audit log
 * to show a full statement; reusable anywhere a stored SQL string needs a nice,
 * copyable read-only view.
 *
 * Props:
 *   open     bool
 *   onClose  () => void
 *   sql      string        the statement to display
 *   title    string        modal heading (default "SQL")
 */
import Modal from './Modal.jsx';
import CodeMirrorSQL from './CodeMirrorSQL.jsx';
import { copyText } from '../lib/export.js';
import { toast } from '../lib/toast.js';

export default function SqlViewerModal(props) {
  const copy = async () => {
    try { await copyText(props.sql || ''); toast.success('SQL copied'); }
    catch (e) { toast.error('Copy failed: ' + e.message); }
  };
  return (
    <Modal open={props.open} onClose={props.onClose} title={props.title || 'SQL'} wide>
      <div class="sql-viewer">
        {/* Show only renders the editor while open, so each open mounts fresh
            with the current SQL (no stale content carried between rows). It
            auto-sizes to the SQL (capped) and wraps long lines. */}
        <div class="sql-viewer-code">
          <CodeMirrorSQL value={props.sql || ''} readOnly lineWrap maxHeight="60vh" minHeight="64px" />
        </div>
        <div class="sql-viewer-actions">
          <button class="btn btn-ghost btn-sm" onClick={copy}>Copy SQL</button>
          <button class="btn btn-sm" onClick={props.onClose}>Close</button>
        </div>
      </div>
    </Modal>
  );
}
